import React from "react";
import {
    Spin,
    Form,
    Card,
    Row,
    Col,
    Input,
    Select,
    Button,
    message,
    Popconfirm,
} from "antd";

import { moaApi } from "../../../../../../api";
import {
    AGENCYCHARGE
} from "../../../../../../utils/constant";

const { Option } = Select;
const { TextArea } = Input;
const {
    reqAgencyAdd,
    reqAgencyDetail,
    reqAgencyEdit,
    reqAgencyDel
} = moaApi;

class AgencyAdd extends React.Component {
    state = {
        loading: true,
        detail: {}
    };
    id = this.props.match.params.id;

    validate = async (values) => {
        let response;
        if (!this.id) {
            for (let i in values) {
                if (!values[i]) {
                    delete values[i];
                }
            }
        }
        if (this.id) {
            values.id = this.id;
            response = await reqAgencyEdit(values);
            if (response && response.data) {
                message.success('修改成功');
                this.props.history.goBack();
            }
        } else {
            values.type = 1;
            response = await reqAgencyAdd(values);
            if (response && response.data) {
                message.success('添加成功');
            }
        }
    };

    delAgency = async (params = {}) => {
        const response = await reqAgencyDel({
            id: this.id
        });
        if (response && response.data) {
            message.success('删除成功');
            this.props.history.replace('/moa/capital/agency/list');
        }
    };

    getAgencyDetail = async (params = {}) => {
        const response = await reqAgencyDetail(params);
        if (response && response.data) {
            this.setState({
                detail: response.data,
                loading: false
            });
        }
    };
    componentDidMount() {
        if (this.id) {
            // 获取详情
            this.getAgencyDetail({
                id: this.id
            });
        }
    }

    render() {
        const { detail } = this.state;

        return this.id && this.state.loading ? (
            <div className="loading-container">
                <Spin size="large" />
            </div>
        ) : (
            <Form onFinish={this.validate} layout="vertical">
                <Card
                    title={
                        this.id ? "修改代理机构信息" : "添加代理机构"
                    }
                    style={{
                        marginBottom: 24,
                    }}
                    bordered={false}
                    extra={
                        this.id ? (
                            <Popconfirm
                                title="确定删除该代理机构信息吗?"
                                onConfirm={this.delAgency}
                                okText="确定"
                                cancelText="取消"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        ) : null
                    }
                >
                    <Card
                        title="代理机构基本信息"
                        bordered={false}
                        type="inner"
                    >
                        <Row gutter={{ sm: 0, md: 16, lg: 24 }}>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="名称"
                                    name="name"
                                    initialValue={detail.name || ''}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请输入代理机构名称',
                                        },
                                    ]}
                                >
                                    <Input placeholder="请输入代理机构名称" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="官网"
                                    name="official_website"
                                    initialValue={detail.official_website || ''}
                                    rules={[
                                        {
                                            type: 'url',
                                            message: '请输入完整官网'
                                        }
                                    ]}
                                >
                                    <Input placeholder="请输入代理机构官网" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                <Form.Item
                                    label="收费级别"
                                    name="charge_level"
                                    initialValue={detail.charge_level ? detail.charge_level : null}
                                    rules={[
                                        {
                                            required: true,
                                            message: '请选择收费级别',
                                        },
                                    ]}
                                >
                                    <Select placeholder="请选择收费级别">
                                        {
                                            AGENCYCHARGE.map((item, index) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.text}
                                                </Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={{ sm: 0, md: 16, lg: 24 }}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item
                                    label="简介"
                                    name="brief"
                                    initialValue={detail.brief || ''}
                                >
                                    <TextArea rows={4} placeholder="请填写简介" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Card>

                <div className="submit-footer">
                    <Button type="primary" htmlType="submit">
                        {
                            this.id ? '保存' : '提交'
                        }
                    </Button>
                </div>
            </Form>
        );
    }
}

export default AgencyAdd;